<template>
  <div style="padding: 2rem; background: #fff">
    <vxe-toolbar
      v-if="
        operateType === 'add' ||
        operateType === 'edit' ||
        operateType === 'renewal' ||
        operateType === 'changeInfo' ||
        operateType === 'changeSubject'
      "
    >
      <template v-slot:buttons>
        <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent">新增</vxe-button>
        <vxe-button
          type="primary"
          class="vxe-btn-delete"
          @click="handleDelete('depositsTable')"
          :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      width="100%"
      align="left"
      show-header-overflow
      class="vxe-table-element"
      show-footer
      :auto-resize="true"
      border
      resizable
      show-overflow
      :data="depositsTableDate"
      :edit-config="editConfig"
      size="mini"
      ref="depositsTable"
      :max-height="$store.state.app.tableHeight"
      :edit-rules="depositsTableEditRules"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        field="rowIndex"
        title="行号"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot="{ row }">{{ row.lineNo || row.currentIndex }}</template>
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.rowIndex"
            @change="(val) => handleRowIndexChange(val, scope.row, scope)"
          >
            <el-option
              v-for="(item, index) in spaceTableData"
              :key="index"
              :label="item.rowIndex"
              :value="item.rowIndex"
            ></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceAreaNo"
        title="片区"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAreaNo"
            clearable
            filterable
            @change="() => handleAreaChange(scope.row, scope, 'depositsTable')"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAreaNo, areaList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceAssetNo"
        title="资产名称"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAssetNo"
            clearable
            filterable
            @change="() => handleAssetsChange(scope.row, scope, 'depositsTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.assetsList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAssetNo, row.assetsList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceUnitNo"
        title="单元（楼栋）"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceUnitNo"
            clearable
            filterable
            @change="() => handleUnitChange(scope.row, scope, 'depositsTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.unitList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceUnitNo, row.unitList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceFloorNo"
        title="楼层"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceFloorNo"
            clearable
            filterable
            @change="() => handleFloorChange(scope.row, scope, 'depositsTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.spaceFloorList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceFloorNo, row.spaceFloorList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceRoomNo"
        title="房号"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceRoomNo"
            clearable
            filterable
            @change="() => handleRoomChange(scope.row)"
          >
            <el-option
              v-for="(item, index) in scope?.row?.roomList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceRoomNo, row.roomList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="depositCategory"
        title="押金类别"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.depositCategory" clearable filterable>
            <el-option
              v-for="(item, index) in depositCategoryList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.depositCategory, depositCategoryList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column field="depositAmount" title="金额" :edit-render="{ type: 'default' }">
        <template v-slot:edit="scope">
          <input-number
            :max="'99999999.99'"
            v-model="scope.row.depositAmount"
            :precision="2"
          ></input-number>
        </template>
      </vxe-table-column>
      <vxe-table-column field="remark" title="备注" :edit-render="{ type: 'default' }">
        <template v-slot:edit="scope">
          <el-input v-model="scope.row.remark" maxlength="20" />
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  export default {
    name: 'deposits',
    props: ['detailDepositsTableData', 'spaceTableData', 'contractCategory', 'contractInfoData'],
    mixins: [leaseContractMixin],
    computed: {
      operateType() {
        return this.$route.query.type;
      },
      depositsTableEditRules() {
        return {
          spaceAreaNo: [
            {
              required: this.isPropertyContract ? true : false,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          spaceAssetNo: [
            {
              required: this.isPropertyContract ? true : false,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          // spaceUnitNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // spaceFloorNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // spaceRoomNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          depositCategory: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          depositAmount: [
            {
              required: true,
              message: '请填写',
              trigger: 'blur',
            },
          ],
        };
      },
    },
    watch: {
      detailDepositsTableData(newVal) {
        if (newVal) {
          this.dealDetailData(newVal);
        }
      },
      contractCategory(val) {
        console.log('====', val);
        if (val == '02') {
          this.isPropertyContract = false;
        }
        if (val == '01') {
          this.isPropertyContract = true;
        }
        console.log('isPropertyContract', this.isPropertyContract);
      },
    },
    data() {
      return {
        depositsTableDate: [],
        editConfig: {},
        depositCategoryList: [],
        isPropertyContract: true, //判断是否为物业合同
      };
    },
    created() {
      this.getArea();
      this.getDepositCategoryList();
    },
    mounted() {
      this.editConfig =
        this.operateType === 'add' ||
        this.operateType === 'edit' ||
        this.operateType === 'renewal' ||
        this.operateType === 'changeInfo' ||
        this.operateType === 'changeSubject'
          ? { trigger: 'dblclick', mode: 'row' }
          : {};
    },
    methods: {
      handleRowIndexChange(val, row, scope) {
        console.log(val, row, scope, '---->>');
        const currentItem = this.spaceTableData.find((item) => item.rowIndex == val);
        console.log(JSON.stringify(currentItem), '选中的');
        row['spaceId'] = currentItem['spaceId'];
        row['spaceAreaNo'] = currentItem['spaceAreaNo'];
        row['spaceAssetNo'] = currentItem['spaceAssetNo'];
        row['assetsList'] = currentItem['assetsList'];
        row['spaceUnitNo'] = currentItem['spaceUnitNo'];
        row['unitList'] = currentItem['unitList'];
        row['spaceFloorNo'] = currentItem['spaceFloorNo'];
        row['spaceFloorList'] = currentItem['spaceFloorList'];
        row['spaceRoomNo'] = currentItem['spaceRoomNo'];
        row['roomList'] = currentItem['roomList'];
        row['spaceArea'] = currentItem['spaceArea'];
        row['currentIndex'] = val;
      },
      async dealDetailData(list) {
        for (let item of list) {
          if (item.spaceAreaNo) {
            await this.getAssetsList(item);
          }
          if (item.spaceAssetNo) {
            await this.getUnitList(item);
          }
          if (item.spaceUnitNo) {
            await this.getSpaceFloorList(item);
          }
          if (item.spaceFloorNo) {
            await this.getRoomList(item);
          }
        }
        this.depositsTableDate = list.map((item, index) => {
          return {
            ...item,
            rowIndex: index + 1,
          };
        });
      },
      insertEvent() {
        console.log('insertEvent');
        this.$refs['depositsTable'].validate((valid) => {
          if (valid) {
            let record = {
              spaceAreaNo: '',
              spaceAssetNo: '',
              spaceUnitNo: '',
              spaceFloorNo: '',
              spaceRoomNo: '',
              depositCategory: '',
              depositAmount: '',
              remark: '',
            };
            this.$refs.depositsTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.depositsTable.setActiveRow(row));
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
